var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"status",style:({ color: _vm.getFontColor(), backgroundColor: _vm.getBackgroundColor() })},[_vm._v(" "+_vm._s(_vm.getText())+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }